import { ProductChargingMode } from '@mews/enums';
import { createHandler } from '@mews/std';
import { BusinessComponentsTextKey as TextKey } from './BusinessComponentsTextKey';

export const getProductChargingTextKeyForBookableServices = (
    value: ProductChargingMode,
    perTimeUnitKey: Mews.TextKey
) =>
    createHandler({
        [ProductChargingMode.Once]: TextKey.ProductChargingOnce,
        [ProductChargingMode.PerTimeUnit]: perTimeUnitKey,
        [ProductChargingMode.PerPersonPerTimeUnit]: TextKey.PerPersonPerTimeUnit,
        [ProductChargingMode.PerPerson]: TextKey.ProductChargingPerPerson,
    })(value);
